import AdminNavigationLayout from 'shared/Layouts/TopNavigationLayout/AdminNavifationLayout'
import TopNavigationLayoutPageContent from 'shared/Layouts/TopNavigationLayout/TopNavigationLayoutPageContent'
import { useNavigate } from 'react-router-dom'
import Button from 'shared/Buttons/Button/Button'
import ProjectRolesTable from './components/ProjectRolesTable'

const ProjectRolesPage = () => {
  const navigate = useNavigate()

  return (
    <AdminNavigationLayout>
      <TopNavigationLayoutPageContent type='default'>
        <div className='flex-space-between'>
          <div className='inline-flex-gap' style={{ gap: '2.5em' }}>
            <h2 className='page--header'>Роли в команде</h2>
          </div>
          <Button theme='primary' style={{ width: 'fit-content' }} onClick={() => navigate('/admin/project-roles/create')}>
            + Создать
          </Button>
        </div>
        <ProjectRolesTable onClick={(t) => navigate('/admin/project-roles/' + t.id)} />
      </TopNavigationLayoutPageContent>
    </AdminNavigationLayout>
  )
}

export default ProjectRolesPage
